import React from 'react';
import classNames from 'classnames';

import styles from './JobIndicatorPreview.module.scss';
import { useWatch } from 'react-hook-form';
import { useEffect } from 'react';


// Allow flexible debug logging for specific acronyms
const allowedAcronymsForDebug = ['S'];

export const JobIndicatorPreview = (props) => {
  const { colors, color_id, acronym, onClick } = props;

  // Development-only logging utility
  const devLog = (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  };

  // Development-only debug logging
  if (allowedAcronymsForDebug.includes(acronym)) {
    devLog('Header JobIndicatorPreview Debug:', {
      color_id,
      acronym,
      colorsLength: colors?.length,
      colors: colors?.slice(0, 3) // Just show first 3 colors
    });
  }

  // Find the color for this job - handle both string and number IDs with proper type conversion
  const jobColor = colors && colors.length > 0 && color_id 
    ? colors.find((color) => String(color.id) === String(color_id)) // Explicit type conversion with strict equality
    : null;
  
  if (allowedAcronymsForDebug.includes(acronym)) {
    devLog('Header color lookup result:', { jobColor, color_id });
  }
  
  
  // Improved fallback strategy for consistent job colors
  const getBackgroundColor = () => {
    // If we found the specific color, use it
    if (jobColor?.hex) {
      return `#${jobColor.hex}`;
    }
    
    // If colors are available but we couldn't find the specific one,
    // use the first color as a consistent fallback
    if (colors && colors.length > 0) {
      const firstColor = colors[0];
      if (firstColor?.hex) {
        devLog('Using first color as fallback:', firstColor);
        return `#${firstColor.hex}`;
      }
    }
    
    // Final fallback to a neutral color only when no colors are available
    devLog('No colors available, using neutral fallback');
    return '#6C757D'; // Bootstrap's secondary color - more professional than #CCCCCC
  };

  const backgroundColor = getBackgroundColor();

  const { height, width, style = {}, className } = props;
  return (
    <div
      className={classNames(styles.jobIndicatorWrapper, styles[className])}
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : undefined,
        backgroundColor: backgroundColor,
        height: height || '50px',
        width: width || '50px',
        ...style,
      }}
    >
      <div className={classNames(styles.jobIndicatorContent)}>{acronym}</div>
    </div>
  );
};
